class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    //this.open();
    /*
     const cartIcon = document.querySelector('[data-cart-icon], .header__icon--cart, .site-header__cart, #cart-icon-bubble');
      if (!cartIcon) return;

      cartIcon.classList.remove('cart-pop-effect');
      void cartIcon.offsetWidth; // reset animation
      cartIcon.classList.add('cart-pop-effect');
      */

      const cart = document.querySelector('#cart-icon-bubble');
      const badge = document.querySelector('#cart-icon-bubble .cart-count-bubble');

      if (!cart) return;

          const rect = cart.getBoundingClientRect();
          const x = rect.left + rect.width / 2;
          const y = rect.top + rect.height / 2;

          // pop animation
          cart.classList.remove('cart-pop-effect');
          void cart.offsetWidth;
          cart.classList.add('cart-pop-effect');

          // badge
          if (badge) {
            badge.classList.remove('pop');
            void badge.offsetWidth;
            badge.classList.add('pop');
          }

          // particles 🎉
          this.createParticles(x, y);

  }

  createParticles(x, y) {
  const colors = ['#000', '#666', '#999', '#ccc'];
  const count = 12;

  for (let i = 0; i < count; i++) {
    const p = document.createElement('div');
    p.className = 'cart-particle';

    const angle = Math.random() * 2 * Math.PI;
    const distance = 40 + Math.random() * 30;

    const tx = Math.cos(angle) * distance + 'px';
    const ty = Math.sin(angle) * distance + 'px';

    p.style.setProperty('--x', tx);
    p.style.setProperty('--y', ty);
    p.style.background = colors[Math.floor(Math.random() * colors.length)];

    p.style.left = x + 'px';
    p.style.top = y + 'px';

    document.body.appendChild(p);

    setTimeout(() => p.remove(), 700);
  }
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
